/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import styled from 'react-emotion';
import { css } from 'emotion';
import Panel from '~/modules/accountManagement/components/basic/Panel';
import Modal, { ModalContent } from '~/modules/core/components/Modal/index';
import { BasicButton } from '~/modules/coreUI/components/legacies/Button';
import { XXLargeSpacer } from '~/modules/coreUI/components/legacies/Spacers';

import FilteringAccordion from './itemsListFilter/FilteringAccordion';

const Icon = styled.i`
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fonts.sizes.xxLarge - 4}px;
`;

const ModalContentUI = styled(ModalContent)`
  padding: 0 ${props => props.theme.paddings.large}px;
`;
const headerTitleStyle = props => css`
  font-size: ${props.theme.fonts.sizes.xLarge - 3}px;
  color: ${props.theme.colors.labels.important};
  letter-spacing: 0.6px;
`;
class ModalFilteringAccordion extends Component {
  state = {
    filteringShown: false,
  };

  render = () => (
    <React.Fragment>
      <Icon className="icon-filter" onClick={() => this.setState({ filteringShown: true })} />
      {this.state.filteringShown && (
        <Modal
          onRef={(ref) => {
            this.modal = ref;
          }}
          onCloseRequested={() => this.setState({ filteringShown: false })}
        >
          <ModalContentUI>
            <Panel
              titleLabel={i18next.t('ecommerceCoreUI:productFilters.Filteration')}
              panelWidth="100%"
              headerTitleStyle={headerTitleStyle}
            />
            <FilteringAccordion panels={this.props.panels} isLoading={this.props.isLoading} />
            <XXLargeSpacer />
            <BasicButton primary fontSize={18.5} onClicked={() => this.modal.closeModal()}>
              {i18next.t('ecommerceCoreUI:productFilters.viewSearchResult')}
            </BasicButton>
            <XXLargeSpacer />
          </ModalContentUI>
        </Modal>
      )}
    </React.Fragment>
  );
}

ModalFilteringAccordion.propTypes = {
  panels: PropTypes.arrayOf(PropTypes.any).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ModalFilteringAccordion;
